import { createImg } from "../DomUtilities/ElementsCreator";
import Description from "../Models/Description";
import Mediator from "../Utilities/Mediator";

export default class DescriptionModal {
	modal: HTMLDivElement;
	descriptions: Array<Description>;
	imageFile: File;
	form: HTMLFormElement;
	infoDiv: HTMLDivElement;
	saveButton: HTMLButtonElement;
	editButton: HTMLButtonElement;
	formVisible: boolean;
	descriptionTextArea: HTMLTextAreaElement;

	constructor() {
		this.modal = document.querySelector('#description-modal');
		this.descriptions = new Array<Description>(); // for now 0 or 1 image and 1 text area
		this.form = this.modal.querySelector('form');
		this.infoDiv = this.modal.querySelector('div#info');
		this.saveButton = this.modal.querySelector('button + button');
		this.editButton = this.modal.querySelector('button + button + button');
		this.descriptionTextArea = this.modal.querySelector('textarea');

		this.addModalButtonsClickListeners();
		this.addImageChangeEventListener();

		if (this.modal.dataset.count) {
			this.displayInfo();
		} else {
			this.displayForm();
		}
	}

	public openModal() {
		this.modal.style.display = "flex";
	}

	private closeModal() {
		this.modal.style.display = "none";
		Mediator.emit("descriptionModalClosed");
	}

	private displayInfo() {
		this.form.style.display = "none";
		this.infoDiv.style.display = "flex";
		this.saveButton.style.display = "none";
		this.editButton.style.display = "inline-block";
		this.formVisible = false;
	}

	private addModalButtonsClickListeners() {
		const closeImg: HTMLImageElement = this.modal.querySelector('img[alt="close icon"]');
		const cancelButton: HTMLButtonElement = this.modal.querySelector('button');

		document.body.onclick = (event) => {
			if (event.target === this.modal) {
				this.descriptions.length = 0;
				this.closeModal();
			}
		}

		closeImg.onclick = () => {
			this.descriptions.length = 0;
			this.closeModal();
		}

		cancelButton.onclick = () => {
			this.descriptions.length = 0;
			this.closeModal();
		}

		this.editButton.onclick = () => {
			this.displayForm();
		}

		this.saveButton.onclick = () => {
			this.saveDescriptions();
		}
	}

	private displayForm() {
		this.form.style.display = "block";
		this.infoDiv.style.display = "none";
		this.saveButton.style.display = "inline-block";
		this.editButton.style.display = "none";
		this.formVisible = true;
	}

	private saveDescriptions() {
		const errorMessage: HTMLParagraphElement = this.modal.querySelector('textarea + p');
		if (this.descriptionTextArea.value.trim()) {
			this.descriptions.length = 0;
			const description = new Description();
			description.text = this.descriptionTextArea.value.trim();
			description.imageFile = this.imageFile;
			this.descriptions.push(description);
			errorMessage.style.opacity = "0";
			this.closeModal();
		} else {
			errorMessage.style.opacity = "1";
		}
	}

	private addImageChangeEventListener() {
		const fileInput: HTMLInputElement = document.querySelector('input[name="infoImage"]');
		const fileDisplayArea: HTMLDivElement = document.querySelector('#infoPic');
		const errorMessage: HTMLParagraphElement = document.querySelector('input[name="infoImage"] + p');
		const sizeLimit: number = 1024 * 1024; // 1MB

		fileInput.onchange = () => {
			fileDisplayArea.innerHTML = "";
			fileInput.style.display = "block";
			fileInput.required = true;
			if (fileInput.value && fileInput.files[0]?.size < sizeLimit) {
				let file = fileInput.files[0];

				let reader = new FileReader();

				reader.onload = function () {
					fileDisplayArea.classList.add('open');
					fileDisplayArea.appendChild(createImg(reader.result.toString()));
				}

				errorMessage.style.opacity = "0";
				this.imageFile = fileInput.files[0];

				reader.readAsDataURL(file);
			} else {
				fileInput.value = "";
				fileDisplayArea.classList.remove('open');
				errorMessage.style.opacity = "1";
			}
		}
	}
}
